import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/salary.scss';
import Color from '@tool/color';
import { CloseIcon20, ArrowDown } from '@styled/icon';
import { newRate } from '@tool/index';
import moSalary from '../store/salary';
import Title from '../../styled/title';
import Tab from '../../styled/tab';
import moUser from '@store/user';
import NonAuth from './non-auth';
import GuessCard from './guess-card';
import CollectCard from './collect-card';
import PositionCard from './position-card';
import moDashboard, {
  changeTime, changeCollectType,
} from '../../store';
import GuessList from './guess-list';
import CollectList from './collect-list';
import PositionList from './position-list';

interface IProps {}
interface IState {}

const MoreButton = styled(Button)(() => ({
  padding: 0,
  marginLeft: '10px',
  lineHeight: 1,
  color: Color.primary,

  '& svg': { transform: 'rotate(270deg)' },
}));

const Salary = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin } = moUser;
  const {
    activeTab, activeTime, collectType,
    isCollect, isGuess, isPosition,
  } = moDashboard;
  const { guessOverview, collectionOverview, historyOverview } = moSalary;

  useEffect(() => {
    return () => {};
  }, []);

  const onMore = () => {
    window.location.href = '/market/marketpay';
  };

  return (
    <>
      {(isCollect || isGuess || isPosition) ? (
        <section className="content-0011 salary-011">
          <section className="title-1155">
            <Title text="职位薪酬动态" />
            <MoreButton onClick={onMore}>更多职位<ArrowDown color={Color.primary} /></MoreButton>
          </section>
          <section className="salary-015">
            <Tab />

            {isLogin ? (
              <section className="salary-021">
                <section className="section-0055">
                  {activeTab === 'collect' ? (
                    <CollectCard overview={collectType === 'history' ? historyOverview : collectionOverview} />
                  ) : null}
                  {activeTab === 'guess' ? <GuessCard /> : null}
                </section>

                {activeTab === 'collect' ? <CollectList /> : null}
                {activeTab === 'guess' ? <GuessList /> : null}
                {activeTab === 'position' ? <PositionList /> : null}
              </section>
            ) : <NonAuth />}
          </section>
        </section>
      ) : null}
    </>
  );
};

export default observer(Salary);
